import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function MapAccountStoreUserService(token,data) {
    return axios.post(`${CURRENT_API_URL}/account/mapAccountStoreUser`,data,{
    headers: {
        'Authorization': token,
    }
    }).then(res => {
        notify.NotifySuccess("Access has been successfully granted to the user for this store. Thank You!");       
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while granting access to the user for this store. please try again later.");
        return false;
    });
}

export default MapAccountStoreUserService;